import { Box, Typography } from "@mui/material";
import { pendingRequestsTableStyles } from "../../styles/styles";
import MyJobsCard from "../MyJobsCard";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

const PendingRequestsTable = (props) => {
  const {
    containerRef,
    data,
    isLoading,
    handleViewButtonClick,
    hasMore,
    loadMore,
  } = props;
  const isMobile = useMediaQuery("(max-width:767px)");
  const { t } = useTranslation("page-my-jobs");

  const { containerStyles, titleBoxStyles, titleText } =
    pendingRequestsTableStyles;

  return (
    <Box sx={containerStyles}>
      <Box sx={{ ...titleBoxStyles, display: isMobile ? "none" : "flex" }}>
        <Typography sx={titleText}>{t("pending_requests")}</Typography>
      </Box>

      <MyJobsCard
        {...{
          containerRef,
          jobsType: "pending",
          data,
          isLoading,
          handleViewButtonClick,
          hasMore,
          loadMore,
        }}
      />
    </Box>
  );
};

export default PendingRequestsTable;
